module.exports = __webpack_public_path__ + "img/pt_dy.ca8b77de.png";